import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

export const ICON_SIZE = 22;

export function useDataSourceIconStyles(styleSet: IStyleSet) {
  return useMemo(
    () => mergeStyleSets(
      {
        icon: {
          width: ICON_SIZE,
          minWidth: ICON_SIZE,
          height: ICON_SIZE,
          fontSize: ICON_SIZE,
          userSelect: `none`
        }
      },
      styleSet
    ),
    [styleSet]
  );
}
